<template>
  <div
    class="item"
    :class="{
      active: isExpanded && highlight,
      expanded: isExpanded,
      labelled: !!this.$slots['label'],
    }"
    @click="clickToOpen && (clicked = !clicked)"
  >
    <div v-if="!!this.$slots['label']" class="ui top attached label">
      <slot name="label"></slot>
    </div>
    <div class="image" v-if="!!this.$slots['image']">
      <slot name="image"></slot>
    </div>
    <div class="content">
      <div class="header">
        <slot name="title"></slot>
      </div>
      <div class="meta right ui grid" v-if="!!this.$slots['meta-columns']">
        <slot name="meta-columns"></slot>
      </div>
      <div class="actions" @click.stop v-if="!!this.$slots['actions']">
        <slot name="actions"></slot>
      </div>
      <div
        class="description"
        v-if="isExpanded && !!this.$slots['description']"
      >
        <slot name="description"></slot>
      </div>
      <transition name="slide-fade">
        <div
          class="extra items"
          v-if="isExpanded && !!this.$slots['extra-items']"
        >
          <slot name="extra-items"></slot>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          class="extra right floated"
          @click.stop
          v-if="isExpanded && !!this.$slots['extra-action']"
        >
          <slot name="extra-action"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  props: {
    expanded: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    clickToOpen: { type: Boolean, default: false },
  },
  data: function () {
    return {
      clicked: false,
    }
  },
  computed: {
    isExpanded(): boolean {
      if (
        !this.$slots["extra-action"] &&
        !this.$slots["extra-items"] &&
        !this.$slots["description"]
      ) {
        return false
      }
      if (this.expanded === undefined) {
        return this.clicked
      } else {
        return this.expanded
      }
    },
  },
})
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
